import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {CardModule} from '../../../../core/component/card/card.module';
import {CreateUpdateDefaultModule} from '../../../../core/component/create-update-default/create-update-default.module';
import {ProductSaveComponent} from './product-save.component';
import {ProductSaveService} from '../../../impl/service/product-save.service';
import {FormFieldModule} from '../../../../core/component/form-field/form-field.module';
import {LovValueSelectFilterModule} from '../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module';
import {NumberInputModule} from '../../../../../components/common/number/number-input/number-input.module';
import {RichTextEditorModule} from '../../../../../components/common/rich-text-editor/rich-text-editor.module';
import {AmountInputModule} from '../../../../../components/common/amount/amount-input/amount-input.module';
import {CheckboxInputModule} from '../../../../../components/common/checkbox/checkbox-input/checkbox-input.module';
import {InputTextModule} from "../../../../core/component/input-text/input-text.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CardModule,
        ReactiveFormsModule,
        CreateUpdateDefaultModule,
        FormFieldModule,
        LovValueSelectFilterModule,
        NumberInputModule,
        RichTextEditorModule,
        AmountInputModule,
        CheckboxInputModule,
        InputTextModule,
    ],
    declarations: [ProductSaveComponent],
    providers: [ProductSaveService],
    exports: [
        ProductSaveComponent
    ]
})
export class ProductSaveModule {
}
